import { GET_DEALERS_START, DEALER_IS_LOADING } from "../actionType";

export const getDealersListAction = () => ({
  type: GET_DEALERS_START,
});
export const dealerIsLoadingAction = (isLoading) => ({
  type: DEALER_IS_LOADING,
  isLoading,
});
